import { ContactTab } from "./default/ContactTab";
import { HomeTab } from "./default/HomeTab";
import { PublicationsTab } from "./default/PublicationsTab";
import { ProjectsTab } from "./default/ProjectsTab";

export const DefaultTabs = {
  Home: HomeTab,
  Contact: ContactTab,
  Publications: PublicationsTab,
  Projects: ProjectsTab,
};
